import type { IconDefinition } from '../index.tsx';

export const iconSidebarLeft: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconSidebarLeft',
  icon: [16, 16, [], '', 'M4 2H0V14H4V2Z M16 2H6V14H16V2Z'],
};
